namespace Matrix.Data {
    export interface AccountValueForm {
        AccountCode: Serenity.StringEditor;
        SourceCode: Serenity.StringEditor;
        InstanceCode: Serenity.StringEditor;
        AsAtDate: Serenity.DateEditor;
        GrossAssetValue: Serenity.DecimalEditor;
        NetAssetValue: Serenity.DecimalEditor;
        Duration: Serenity.DecimalEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class AccountValueForm extends Serenity.PrefixedContext {
        static formKey = 'Data.AccountValue';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!AccountValueForm.init)  {
                AccountValueForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.DecimalEditor;
                var w3 = StaticTextBlock;
                var w4 = ReadOnlyDateTime;

                Q.initFormType(AccountValueForm, [
                    'AccountCode', w0,
                    'SourceCode', w0,
                    'InstanceCode', w0,
                    'AsAtDate', w1,
                    'GrossAssetValue', w2,
                    'NetAssetValue', w2,
                    'Duration', w2,
                    'CreatedBy', w3,
                    'CreatedWhen', w4,
                    'UpdatedBy', w3,
                    'UpdatedWhen', w4,
                    'Version', w3
                ]);
            }
        }
    }
}
